import React, {Component} from 'react';
import {Redirect} from 'react-router';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import * as Actions from '../actions';
import Settings from '../lib/settings';

class Payment extends Component {

  constructor(props) {
    super(props);
    this.state = {
      urlGet: queryString.parse(this.props.location.search)
    };
    window.scrollTo(0, this.props.menuPosition);
  }

  componentDidMount() {
    if(typeof this.state.urlGet.id !== "undefined" && this.state.urlGet.id !== "") {
      fetch('/api/orders/payment/' + this.state.urlGet.id, Settings.fetchParams('GET')).then(res => res.json()).then(json => {
        console.log(json);
      });
    }
  }



  render() {

    console.log(this.state.urlGet);
    return <div>{this.state.urlGet.id}</div>;
  }
}
function mapStateToProps(state) {
  return {admin: state.admin, auth: state.auth, user: state.user, menuPosition: state.menuPosition, cart: state.cart};
}
export default connect(mapStateToProps)(Payment);



// WEBPACK FOOTER //
// ./src/pages/Payment.js